// ===========================================
// MiniKpiCard — Carte KPI compacte pour le header des pages liste
// Plus petite que le KpiCard du dashboard (1 ligne, horizontale)
// ===========================================
import React from 'react';
import { Skeleton } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

const TONE_STYLES = {
    blue:   { color: '#1A2B5F', bg: 'rgba(26, 43, 95, 0.10)' },
    red:    { color: '#C8102E', bg: 'rgba(200, 16, 46, 0.10)' },
    green:  { color: '#16a34a', bg: 'rgba(22, 163, 74, 0.10)' },
    orange: { color: '#ea580c', bg: 'rgba(234, 88, 12, 0.10)' },
    purple: { color: '#7c3aed', bg: 'rgba(124, 58, 237, 0.10)' },
    grey:   { color: '#475569', bg: 'rgba(71, 85, 105, 0.10)' },
    teal:   { color: '#0891b2', bg: 'rgba(8, 145, 178, 0.10)' },
    indigo: { color: '#4f46e5', bg: 'rgba(79, 70, 229, 0.10)' },
};

const MiniKpiCard = ({ icon, label, value, suffix, delta, tone = 'blue', loading = false }) => {
    const t = TONE_STYLES[tone] || TONE_STYLES.blue;

    if (loading) {
        return (
            <div className={`mini-kpi mini-kpi-${tone}`}>
                <Skeleton active title={false} paragraph={{ rows: 2, width: ['50%', '70%'] }} />
            </div>
        );
    }

    return (
        <div className={`mini-kpi mini-kpi-${tone}`}>
            <div className="mini-kpi-icon" style={{ background: t.bg, color: t.color }}>
                {icon}
            </div>
            <div className="mini-kpi-body">
                <div className="mini-kpi-label">{label}</div>
                <div className="mini-kpi-value">
                    {value ?? 0}
                    {suffix && <span className="mini-kpi-suffix"> {suffix}</span>}
                </div>
            </div>
            {delta !== undefined && delta !== null && (
                <div className={`mini-kpi-delta ${delta >= 0 ? 'up' : 'down'}`}>
                    {delta >= 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                    <span>{delta >= 0 ? '+' : ''}{delta}%</span>
                </div>
            )}
        </div>
    );
};

export default MiniKpiCard;
